import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';



import { DownloadFile } from '@asd-stan/standard/components/download-file/download-file';
import { JustificationChanges } from '@asd-stan/standard/components/single-standard/tabs-sections/single-standard-page-section/page-blocks/justification/justifiaction-changes/justification-changes';
import { Justification as JustificationData } from '@asd-stan/standard/domain/standard-detailed.entity';
import { InputGroup } from '@asd-stan/user/components/layout/input-group/input-group';
import { getStandardDetailsService } from 'src/standard/infrastructure/getters';



import {
	StandardDisplayField,
	StandardDisplayFieldHeader,
	StandardDisplayFieldValue,
	StandardDisplayFieldValueAbsent,
	StandardDisplayRow,
	StandardReference,
	TitleContainer,
} from '../../single-standard.styled';

import {
	JustificationContainer,
	JustificationLinkContainer,
	LinkContainer,
	LinkStyles,
} from './justification-components.styled';
import {
	SingleStandardField
} from 'src/standard/components/single-standard/tabs-sections/single-standard-page-section/single-standard-field';


export const JustificationEa: FC = props => {
	const { t } = useTranslation();
	const standardDetailsService = getStandardDetailsService();

	const languageNames = new Intl.DisplayNames(['en'], {
		type: 'language',
	});
	const titles = Object.values(standardDetailsService.standard?.titles ?? {});
	const titlesKeys = Object.keys(standardDetailsService.standard?.titles ?? {});

	return (
		<InputGroup title={t('standard.singleStandardPage.justification.titleEa')}>
			<JustificationContainer>

				{!!standardDetailsService.standard?.titles && (
					<>
						<TitleContainer key={`${titlesKeys[0]}`}>
							<StandardDisplayFieldHeader>{`${t(
								'standard.singleStandardPage.titles.standardTitleIn'
							)} ${languageNames.of(titlesKeys[0])}`}</StandardDisplayFieldHeader>
							{titles[0] ? (
								<StandardDisplayFieldValue key={titles[0]}>{titles[0]}</StandardDisplayFieldValue>
							) : (
								<StandardDisplayFieldValueAbsent>
									{t('standard.singleStandardPage.titles.titleAbsent')}
								</StandardDisplayFieldValueAbsent>
							)}
						</TitleContainer>
						<TitleContainer key={`${titlesKeys[2]}`}>
							<StandardDisplayFieldHeader>{`${t(
								'standard.singleStandardPage.titles.standardTitleIn'
							)} ${languageNames.of(titlesKeys[2])}`}</StandardDisplayFieldHeader>
							{titles[2] ? (
								<StandardDisplayFieldValue key={titles[2]}>{titles[2]}</StandardDisplayFieldValue>
							) : (
								<StandardDisplayFieldValueAbsent>
									{t('standard.singleStandardPage.titles.titleAbsent')}
								</StandardDisplayFieldValueAbsent>
							)}
						</TitleContainer>
						<TitleContainer key={`${titlesKeys[1]}`}>
							<StandardDisplayFieldHeader>{`${t(
								'standard.singleStandardPage.titles.standardTitleIn'
							)} ${languageNames.of(titlesKeys[1])}`}</StandardDisplayFieldHeader>
							{titles[1] ? (
								<StandardDisplayFieldValue key={titles[1]}>{titles[1]}</StandardDisplayFieldValue>
							) : (
								<StandardDisplayFieldValueAbsent>
									{t('standard.singleStandardPage.titles.titleAbsent')}
								</StandardDisplayFieldValueAbsent>
							)}
						</TitleContainer>
					</>
				)}

				<StandardDisplayRow>
					<SingleStandardField
						header={t('standard.singleStandardPage.general.scope')}
						value={standardDetailsService.standard?.scope || ''}
						fallbackText={t('standard.singleStandardPage.general.scopeAbsent')}
					/>
				</StandardDisplayRow>

				<StandardDisplayField>
					<StandardDisplayFieldHeader>
						{t('standard.singleStandardPage.justification.purpose')}
					</StandardDisplayFieldHeader>
					{standardDetailsService.standard?.justification.purpose ? (
						<StandardDisplayFieldValue>{standardDetailsService.standard?.justification.purpose}</StandardDisplayFieldValue>
					) : (
						<StandardDisplayFieldValueAbsent>
							{t('standard.singleStandardPage.justification.purposeAbsent')}
						</StandardDisplayFieldValueAbsent>
					)}
				</StandardDisplayField>

			</JustificationContainer>
		</InputGroup>
	);
};
